/**
 * 专门用来处理旧的组件数据为新的数据，后续扩展新的格式兼容，统一在此处理
 * @param {*} components
 * @returns
 */
export const normalizeComponents = (components, data) => {
  let flowManagementType = data.flowManagementType || "card-vertical";
  components.forEach((item) => {
    //将老数据gridconmengt最小高度，宽度值初始化为前端初始化值------start
    if (
      item.id === "flowManagement" ||
      (item.id === "flowManagementV2" && !data.flowManagementType)
    ) {
      if (item.w === 60) {
        item.id = "flowManagementV2";
        item.minH = 6;
        item.maxH = 6;
        item.h = 6;
        item.minW = 60;
        item.maxW = 60;
        item.w = 60;
        flowManagementType = "card-cross";
      } else {
        item.id = "flowManagementV2";
        item.minH = 8;
        item.maxH = 8;
        item.h = 8;
        item.minW = 40;
        item.maxW = 40;
        item.w = 40;
      }
      data.flowManagementType = flowManagementType;
    }
    //将老数据gridconmengt最小高度，宽度值初始化为前端初始化值------end
  });
};
